import React, { useCallback } from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import CorpHeader from './CorpHeader';
import CorpHero from './CorpHero';
import CorpAbout from './CorpAbout';
import CorpGrowth from './CorpGrowth';
import CorpBusiness from './CorpBusiness';
import CorpTech from './CorpTech';
import CorpHiks from './CorpHiks';
import CorpPeople from './CorpPeople';
import CorpImpact from './CorpImpact';
import CorpContact from './CorpContact';
import CorpFooter from './CorpFooter';
import CorpTopButton from './CorpTopButton';
import { useReveal } from './hooks';

/**
 * 기업 소개 메인('/'). BNPL 상담·접수 원페이지는 /bnpl 로 분리했고
 * 헤더의 'BNPL 서비스' 버튼과 사업영역·문의 카드가 그쪽으로 보낸다.
 */
const CorporatePage = () => {
  const revealRef = useReveal();

  const go = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <>
      <div className={s.page}>
        <CorpHeader onNavigate={go} />

        <main ref={revealRef}>
          <CorpHero onNavigate={go} />
          <CorpAbout />
          <CorpGrowth />
          <CorpBusiness onNavigate={go} />
          <CorpTech />
          <CorpHiks />
          <CorpPeople />
          <CorpImpact />
          <CorpContact />
        </main>

        <CorpFooter onNavigate={go} />
      </div>

      {/* .page 의 overflow-x: clip 에 잘리지 않도록 바깥에 둔다 */}
      <CorpTopButton />
    </>
  );
};

export default CorporatePage;
